export default {
  wordCount: {
    title: 'Word count',
    message:
      '<p>It is recommended to have between 150 and 350 words in the cover letter.</p>',
  },
  contactInformation: {
    title: 'Contact information',
    message: `
      <p>Make sure to include your contact information so that recruiters can get in touch with you.</p>
      <p>It is recommended that the cover letter contain your phone number, email address, and physical address.</p>
    `,
  },
  companyInformation: {
    title: 'Company information',
    message: `
      <p>Make sure to include company information in the cover letter.</p>
      <p>It is recommended that the cover letter contain the company name, job title, and company physical address</p>
    `,
  },
  measurableResults: {
    title: 'Measurable Results',
    message: `
    <p>Recruiters scanning cover letters typically notice and hone in on definitive results, shown in numbers.
    The more specific you can be (while remaining concise), the better- add dates, length of time, and accurate numbers whenever possible.</p>
    <h5>Examples</h5>
    <ul>
      <li>"Supervised up to 25 employees..."</li>
      <li>"Reduced labor costs by more than 15%..."</li>
      <li>"Increased sales from $1.2 to $2.5 million in 2017..."</li>
      <li>"Ranked in top 5% of employee performance for 3 years running..."</li>
    </ul>
    <h5>Measurable result categories</h5>
    <strong>Money</strong>
    <ul>
      <li>sales volume</li>
      <li>number of units sold</li>
      <li>dollars and percentages with revenue</li>
      <li>share holder value increase</li>
      <li>cost savings</li>
      <li>budgets or funds served</li>
    </ul>
    <strong>People</strong>
    <ul>
      <li>numbers of customers served</li>
      <li>number of customers retained</li>
      <li>number of new customers</li>
      <li>numbers of direct reports</li>
      <li>number of people managed or hired</li>
      <li>size of teams led</li>
    </ul>
    <strong>Tasks</strong>
    <ul>
      <li>numbers of any tasks done in great quantity</li>
      <li>efficiency increases</li>
      <li>process improvements</li>
      <li>time saved</li>
    </ul>
    <strong>Other</strong>
    <ul>
      <li>numbers of awards or publications</li>
    </ul>
    `,
  },
  coverLetterTone: {
    title: 'Words to avoid',
    message: `
    <p>Hiring managers and recruiters prefer action words that define specific experiences,
    skills and accomplishments rather than cliched phrases, buzzwords or over-aggressive tones.</p>
    <h5>Examples of negative words or phrases</h5>
    <ul>
      <li><strong>Best of Breed</strong><div>Avoid cliches that does not bring value - leave the dog at home</div></li>
      <li><strong>Synergy</strong><div>Avoid phony business jargon. Use more concrete language to convey your point more effectively.</div></li>
      <li><strong>Results driven</strong><div>Avoid vague self-appointed adjectives. Instead, show you’re results driven (or otherwise) with actual impressive results you achieved.</div></li>
      <li><strong>Aggressive close of deals</strong><div>Avoid phrases that are overly negative in tone</div></li>
    </ul>
    `,
  },
}
